import type { AuthProvider } from "react-admin";
import {
  ApiError,
  getSnapshot,
  loadCurrentUser,
  login,
  logout,
} from "./client";

export const authProvider: AuthProvider = {
  login: async ({ username, email, password }) => {
    await login(email || username || "", password || "");
  },
  logout: async () => {
    try {
      await logout();
    } catch {
      // The local session is already cleared even if revocation is unavailable.
    }
  },
  checkAuth: async () => {
    if (!getSnapshot().authenticated) throw new Error("Please sign in.");
  },
  checkError: async (error: unknown) => {
    if (
      error instanceof ApiError &&
      error.status === 401 &&
      !getSnapshot().authenticated
    ) {
      throw error;
    }
  },
  getIdentity: async () => {
    if (getSnapshot().passwordChangeRequired) {
      throw new ApiError(403, { error: "password_change_required" });
    }
    const user = getSnapshot().user || (await loadCurrentUser());
    return { id: user.userId, fullName: user.email };
  },
  getPermissions: async () => getSnapshot().user?.role,
  canAccess: async () =>
    getSnapshot().authenticated && !getSnapshot().passwordChangeRequired,
};
